import React from "react"
import QrPageV2 from "./QrPageV2";
import QrPageV3 from "./QrPageV3";

const AppQr = ({version}) => {
    return (
        <>
            {version === 2 && <QrPageV2/>}
            {version === 3 && <QrPageV3/>}
        </>
    );
}

export default AppQr